import { CSSObject } from "@emotion/react";
import { constants, mediaQueryStyles } from "@newsela/angelou";

const { mediaQuery: breakpoint } = mediaQueryStyles;
const {
  breakpoints: { BreakpointNames },
} = constants;

export const containerCss: CSSObject = {
  maxWidth: "calc(100vw - 310px)",
  [breakpoint.upTo(BreakpointNames.md)]: {
    maxWidth: "calc(100vw - 30px)",
  },
};
